var _defs, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmStat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-stat_svg__a",
    d: "M9.7 10.2V7.6c0-.2.1-.3.3-.3h.6c.2 0 .3.1.3.3v2.5c0 .2-.1.3-.3.3H10c-.2 0-.3-.1-.3-.2zm-2.3 0v-4c0-.2.1-.3.3-.3h.6c.2 0 .3.1.3.3v3.9c0 .2-.1.3-.3.3h-.6c-.1 0-.3-.1-.3-.2zm4.5 0V5.1c0-.2.1-.3.3-.3h.6c.2 0 .3.1.3.3v5.1c0 .2-.1.3-.3.3h-.6c-.1-.1-.3-.2-.3-.3zm-6.7 0V7.9c0-.2.1-.3.3-.3H6c.2 0 .3.1.3.3v2.2c0 .2-.1.3-.3.3h-.5c-.2 0-.3-.1-.3-.2zM3.5 3.4s-.1 0 0 0l-.1 8.5s0 .1.1.1h11.2s.1 0 .1-.1V3.4s0-.1-.1-.1H3.5zm7.6 11.3h1.7c.3 0 .6.3.6.6s-.3.6-.6.6H5.5c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h1.7v-1.8H3.5c-.6 0-1.1-.5-1.1-1.1V3.4c0-.6.5-1.1 1.1-1.1h11.2c.6 0 1.1.5 1.1 1.1v8.4c0 .6-.5 1.1-1.1 1.1H11v1.8zM10 12.9H8.3v1.8H10v-1.8z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "crm-stat_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-stat_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crm-stat_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "crm-stat_svg__c",
    d: "M-785.9-1434h1424V560h-1424z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "crm-stat_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#crm-stat_svg__c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#crm-stat_svg__d)",
    d: "M-2.6-2.6h23.4v23.4H-2.6z"
  }))));
}

export default SvgCrmStat;